import React, {
  useRef,
  createContext,
  useContext,
  useCallback,
  useEffect,
  useState,
} from "react";

const useInitSubscribableStore = () => {
  const store = useRef({
    isOpen: false,
    saveData: null,
  });

  const subscribers = useRef(new Set());

  const subscribe = useCallback((callback) => {
    subscribers.current.add(callback);
    return () => subscribers.current.delete(callback);
  }, []);

  const get = useCallback(() => store.current, []);

  const set = useCallback((value) => {
    store.current = { ...store.current, ...value };
    subscribers.current.forEach((callback) => callback());
  }, []);

  return {
    subscribe,
    get,
    set,
  };
};
const FollowDialogContext = createContext();

const FollowDialogProvider = ({ children }) => {
  return (
    <FollowDialogContext.Provider value={useInitSubscribableStore()}>
      {children}
    </FollowDialogContext.Provider>
  );
};

// subscribeTo is a function that should take the store and return the part of the store you want to subscribe to
// (store) => store - subscribes to entire store
// (store) => store.isOpen - subscribes to isOpen and only updates on changes to isOpen
const useFollowDialogStore = (subscribeTo) => {
  const context = useContext(FollowDialogContext);
  if (context === undefined) {
    throw new Error(
      "useFollowDialogStore must be used within a FollowDialogProvider"
    );
  }

  const [state, setState] = useState(subscribeTo(context.get()));

  useEffect(() => {
    return context.subscribe(() => setState(() => subscribeTo(context.get())));
  }, [subscribeTo, context]);

  return [state, context.set];
};

const SubscribeToAll = (store) => store;
const SubscribeToNothing = (store) => store.NONE;

export {
  useFollowDialogStore,
  FollowDialogProvider,
  SubscribeToAll,
  SubscribeToNothing,
};
